<template>
      <div :class="UseColumnDinamic ? Column : 'col-md-3'">
		<MdPatientAllergiesOutCome v-if="activateModalAllergies"
			v-bind:ModalId="ModalIdAddAllergy"
			v-bind:PatientCode="this.PatientCode"
			v-bind:AdmissionRecordId="this.AdmissionRecordId"
			v-bind:TitleWindow="$t('Shared.AddAllergy')"
			@getCodeConditionOK="onCodeConditionOk($event)"
			@getCancel="onCancel($event)"
			v-bind:NoValidateChanges="NoValidateChanges"
		></MdPatientAllergiesOutCome>
					<div class="card activeCard">
						<div class="card-body">

					<div v-if="isUsePatientAllergies" class="d-flex align-items-start justify-content-between pointer forceLTR">
							<h6 v-on:click="GoToPatientAllergies" class="card-title flex-grow lower-line text-truncate"><i class="mdi mdi-alert text-warning mr-1"></i>{{ $t('Shared.PatientAllergies') }}</h6>
							<i v-if="!HideViewAllergy" class="mdi mdi-arrow-right-drop-circle text-corporate" v-on:click="GoToPatientAllergies" ></i>
							<!--<i v-if="VisibleAddAllergy" v-b-modal="ModalIdAddAllergy" class="mdi mdi-plus text-corporate mx-1" ></i>-->
					</div>
					<div v-if="!isUsePatientAllergies" class="d-flex align-items-start justify-content-between">
							<h6 class="card-title flex-grow lower-line text-truncate"><i class="mdi mdi-alert text-warning"></i>{{ $t('Shared.PatientAllergies') }}</h6>
					</div>
					<div :class="NoUseClass ? 'text-muted cutescroll': UseFixedMiddleClass ? 'text-muted p-middle-fixed cutescroll' : 'text-muted p-fixed cutescroll'">
						<p v-if="hasNoKnownAllergies">{{ $t('MdPatientAllergies.NKATo') }} {{ nkaItemsList }}</p>
						<p v-if="!NoKnownAllergies && Allergies.length === 0">{{ $t('MdPatientAllergies.AllergiesNotReviewed') }}</p>
						<p v-else-if="NoKnownAllergies && !hasNoKnownAllergies && Allergies.length === 0">{{ $t('MdPatientAllergies.NoKnownAllergies') }}</p>
						<p v-if="Allergies.length > 0">{{ $t('Shared.PatientAllergies') }}</p>
						<ul>
							<li v-for="(it, index) in Allergies" :key="`it.allergy-${index}`">{{it.allergy}}</li>
						</ul>
						</div>
						</div>
					</div>




					</div>

</template>

<script>
import DBFunctions from '@/common/DBFunctions.js'
import AllergyService from '@/services/allergies.service'
//import { EventBus } from '@/event-bus.js';
  export default {
    props: {
    PatientCode: String,
	UseColumnDinamic:Boolean,
	Column:String,
	NoUseClass:Boolean,
	HideViewAllergy:Boolean,
	VisibleAllergy:Boolean,
	ModalIdAddAllergy:String,
    UseFixedMiddleClass:Boolean,
	NoValidateChanges: Boolean,
	AdmissionRecordId:String,
	},
    mixins: [DBFunctions],

	//components: { Allergy },
    data() {
      return {
		Allergies:[],
		NoKnownAllergies: null,
		activateModalAllergies:false,
		isUsePatientAllergies: this.$store.state.isUsePatientAllergies,

      }
    },

	computed: {
		hasNoKnownAllergies() {
			return this.NoKnownAllergies && (
				this.NoKnownAllergies.drug ||
				this.NoKnownAllergies.food ||
				this.NoKnownAllergies.substance ||
				this.NoKnownAllergies.animal ||
				this.NoKnownAllergies.environmental
			);
		},
		nkaItemsList() {
			if (!this.hasNoKnownAllergies) return '';
			const items = [];
			if (this.NoKnownAllergies.drug) items.push(this.$t('drug.Drug'));
			if (this.NoKnownAllergies.food) items.push(this.$t('AllergiesList.Food'));
			if (this.NoKnownAllergies.substance) items.push(this.$t('Shared.Substance'));
			if (this.NoKnownAllergies.animal) items.push(this.$t('AllergiesList.Animal'));
			if (this.NoKnownAllergies.environmental) items.push(this.$t('AllergiesList.Environmental'));
			return items.join(', ');
		}
	},

  methods:{
	async getAllergies(){
		this.Allergies.splice(0,this.Allergies.length);
		this.NoKnownAllergies = null;
		this.Allergies = await this.getPatientAllergy(this.PatientCode);
		await AllergyService.getPatientNoKnownAllergie(this.PatientCode)
			.then((response) => {
				if (response.status === 200 && response.data && response.data.length > 0) {
					this.NoKnownAllergies = response.data[0];
				}
			})
			.catch(() => {});
	},

	GoToAddAllergy(){

	},

	async deActivateModal(){
		this.Allergies.splice(0,this.Allergies.length);
		this.activateModalAllergies = false;

		this.Allergies = await this.getPatientAllergy(this.PatientCode);
     },

	onCancel(){
		this.deActivateModal();
     },

	onCodeConditionOk() {
		this.deActivateModal();
     },

	GoToPatientAllergies(){

		if(!this.VisibleAllergy){
			if(this.$route.name.includes('patient')){
				this.$router.push({ name: "patient-allergies", params: { id: this.PatientCode } }).catch(()=>{});
			}
			if(this.$route.name.includes('Clinical')){
				this.$router.push({ name: "Clinical-PatientAllergies", params: { id: this.PatientCode,recordid:this.$route.params.recordid } }).catch(()=>{});
			}
            if(this.$route.name.includes('appointment')){
				this.$router.push({ name: "appointmentDB-allergies", params: { id: this.PatientCode,recordid:this.$route.params.recordid } }).catch(()=>{});
			}
		}else{
			this.activateModalAllergies = true;
		}

    },
  },
  created(){
	/*EventBus.$on("CloseModalAddAllergyMed", function () {
        this.closeModal();
    }.bind(this));*/
  },
  mounted() {
	this.getAllergies();
  },
  beforeDestroy () {
       //EventBus.$off('CloseModalAddAllergyMed');
	},
}

</script>
